<template>
  <div>
    <div class="inventoryTransfer" v-show="!isAddBilling">
      <!-- 费用管理 常规仓储费 -->
      <baseBreadcrumb :page="$t('message.regularStorageFee')" :menu="$t('message.costManagement')">
      </baseBreadcrumb>
      <div class="body">
        <div class="btn">
          <!-- 新增计费 -->
          <el-button type="success" @click="addRegularStorageFee">{{ $t('message.addRegularStorageFee')
          }}</el-button>
        </div>
        <div class="table">
          <ol style="background-color: #EDEFF4;">
            <li class="flex05">No</li>
            <!-- 最后修改时间 -->
            <li>{{ $t('message.lastModifiedTime') }}</li>
            <!-- 当前生效时间 -->
            <li>{{ $t('message.currentEffectiveTimes') }}</li>
            <!-- 价格区间 -->
            <li>{{ $t('message.priceRange') }}</li>
            <!-- 状态 -->
            <li>{{ $t('message.status') }}</li>
            <!-- 操作-->
            <li>{{ $t('message.operation') }}</li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li class="flex05">{{ item.rowNumber }}</li>
            <!-- 最后修改时间 -->
            <li>{{ item.updated_at }}</li>
            <!-- 当前生效时间 -->
            <li>
              <div>
                <p>{{ item.start_date }}</p>
                <p>{{ item.end_date }}</p>
              </div>
            </li>
            <!-- 价格区间 -->
            <li>
              <div class="template">
                <div class="row" v-for="(config, configIndex) in item.config_data_formatted" :key="configIndex">
                  <h6>{{ config.level_name }}</h6>
                  <p v-for="(ranges_text, rangesIndex) in config.ranges_text" :key="rangesIndex">{{ ranges_text }}</p>
                </div>
              </div>
            </li>
            <!-- 状态 -->
            <li>
              <el-switch v-model="item.status" active-color="#13ce66" @change="changeStatus(item)">
              </el-switch>
            </li>
            <!-- 操作-->
            <li>
              <div>
                <!-- 编辑 -->
                <p>
                  <el-button type="primary" class="primary" @click="editConfig(item)">{{ $t('message.compile')
                  }}</el-button>
                </p>
                <!-- 复制一条 -->
                <p>
                  <el-button type="primary" @click="copyConfig(item)">{{ $t('message.toCopyA') }}</el-button>
                </p>
                <!-- 删除 -->
                <p>
                  <el-button type="danger" class="dark" @click="deleteConfig(item)">{{ $t('message.delete')
                  }}</el-button>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 新增计费 -->
    <addBilling v-show="isAddBilling" ref="addBilling"></addBilling>
  </div>
</template>
<script>
import addBilling from './components/addBilling.vue'
export default {
  data() {
    return {
      tableData: [],
      isAddBilling: false,
    }
  },
  components: {
    addBilling,
  },
  created() {
    this.storageFeeClientConfigList();
  },
  methods: {
    // 常规仓储费-获取计费类型列表
    storageFeeClientConfigList() {
      this.$api.costManagementApi.storageFeeClientConfigList({ pageSize: 999 }).then(res => {
        res.data.data.forEach((item, index) => {
          item.status = item.status == 1 ? true : false;
          item.config_data.forEach((config, configIndex) => {
            if (config.client_level_ids) {
              config.client_level_ids = config.client_level_ids.map(id => id - 0)
            } else {
              config.client_level_ids = ['all']
            }
          })
        })
        this.tableData = res.data.data;
      })
    },
    // 常规仓储费-复制一条
    copyConfig(item) {
      this.$api.costManagementApi.storageFeeClientConfigCopy({ id: item.id }).then(res => {
        this.$message.success(res.msg);
        this.storageFeeClientConfigList();
      })
    },
    // 常规仓储费-删除一条
    deleteConfig(item) {
      this.$confirm(this.$t('message.areYouSureToDelete'), this.$t('message.confirm'), {
        confirmButtonText: this.$t('message.confirm'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning',
        center: true,
      }).then(() => {
        this.$api.costManagementApi.storageFeeClientConfigDelete({ id: item.id }).then(res => {
          this.$message.success(res.msg);
          this.storageFeeClientConfigList();
        })
      }).catch(() => {

      });
    },
    // 常规仓储费-状态切换
    changeStatus(item) {
      let datas = {
        id: item.id,
        status: item.status ? 1 : 0,
        start_date: item.start_date,
        end_date: item.end_date,
        fee_type: item.fee_type,
        config_data: item.config_data,
      }
      this.$api.costManagementApi.storageFeeClientConfigUpdate(datas).then(res => {
        this.$message.success(res.msg);

      })
      this.storageFeeClientConfigList();
    },
    // 常规仓储费-新增计费
    addRegularStorageFee() {
      this.isAddBilling = true
      this.$refs.addBilling.form = {
        customerLevel: '',
        start_date: '',
        end_date: '',
        fee_type: 'three_side_sum',
        status: 0,
        config_data: [
          {
            client_level: '',
            client_level_ids: [],
            ranges: [
              {
                range_start: '',
                range_end: '',
                price: 0,
              }
            ],

          }
        ]
      }
      this.$refs.addBilling.time = []
      this.$refs.addBilling.isAdd = true
    },
    // 常规仓储费-编辑
    editConfig(item) {
      this.isAddBilling = true
      this.$refs.addBilling.isAdd = false
      this.$refs.addBilling.form = JSON.parse(JSON.stringify(item))
      this.$refs.addBilling.time = [item.start_date, item.end_date]
    }

  }
}
</script>
<style scoped lang="scss">
.inventoryTransfer {
  .btn {
    margin-bottom: 20px;
  }

  .table {
    .flex05 {
      flex: 0.5;
    }

    .flex2 {
      flex: 2;
    }

    ol {
      background: #DCDFE6;
      height: 56px;
      line-height: 56px;
      color: #666666;
    }

    ul {
      padding: 20px 0;
      background-color: #fff;
      text-align: center;

      h6 {
        line-height: 22px;
        color: #333333;
        margin-bottom: 6px;
        font-weight: bold;
      }

      p {
        line-height: 22px;
        margin-bottom: 6px;

        .el-button {
          width: 80px;
          padding: 11px 0;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .template {
      width: 100%;
      text-align: left;

      .row {
        margin-bottom: 12px;
      }

    }


  }
}
</style>
